import useSWR from "swr";
import { URL_API } from "../../../@richbeauty/services/endpoint";
import jwtAxios from "../../../@richbeauty/services/auth/jwt-auth/jwt-api";

const getUsers = async (params) => {
  return await jwtAxios.get(URL_API.CMS_USERS.GET_USERS, { params });
};
const useGetUsers = (params) => {
  const fetcher = () => getUsers(params);
  return useSWR(
    {
      url: URL_API.CMS_USERS.GET_USERS,
      params,
      tags: ["#users", "#roleRelated", "#agentRelated"],
    },
    fetcher
  );
};
export default useGetUsers;
